export default __webpack_public_path__ + "static/media/Google_mic.svg.f6f1195f.png";